/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import datasetTypes from '../../enums/datasetTypes';
import TimeSeriesGenericChartVisualization from './chart/TimeSeriesGenericChartVisualization';
import timeSeriesChartVisualizationStaticPropertiesReducer from './chart/reducers/timeSeriesChartVisualizationReducer';

export class TimeSeriesAreaVisualization extends TimeSeriesGenericChartVisualization {

    getChartSection() {
        const section = super.getChartSection();
        return {
            ...section,
            type: 'area'
        };
    }
}

export const TimeSeriesAreaVisualizationDescriptor = {
    legacyAdhoc: 'area_time_series',
    parentClass: 'Time',
    cssClass: 'Area',
    bundleName: 'adhoc.visualisation.chooser.type.AREA_TIME_SERIES',
    name: 'TimeSeriesArea',
    group: 'adhoc.visualisation.chooser.type.GROUP_TIME_SERIES',
    datasetType: datasetTypes.MULTI_AXIS,
    component: TimeSeriesAreaVisualization,
    staticPropertiesReducer: timeSeriesChartVisualizationStaticPropertiesReducer,
    isTimeSeries: true,
    requirements: {
        measures: {
            min: 1,
            inRow: false
        },
        fields: {
            min: 1,
            type: 'time',
            categorizer: [
                'day',
                'hour',
                'minute',
                'second',
                'millisecond',
                'hour_by_day',
                'minute_by_day',
                'second_by_day',
                'millisecond_by_day'
            ]
        }
    }
};
